(function () {
    var $form = $('.corporate form');

    if ($form.length === 0) return;

    // Form validation
    var options = {
        groupClass: 'has-error',
        groupSelector: '.form-group',
        errorPosClasses: ['.input-group', '.selectize-control'],
        helpSpanDisplay: 'help-block',
        delay: false,
        disableSubmitBtn: false,
    };

    var metrics = [
        ['input[name="name"]', 'presence', gmtrans('corporate.apply.frontend_validation.name_required')],
        [
            'input[name="company_name"]',
            'presence',
            gmtrans('corporate.apply.frontend_validation.company_name_required'),
        ],
        ['input[name="address"]', 'presence', gmtrans('corporate.apply.frontend_validation.address_required')],
        ['input[name="email"]', 'presence', gmtrans('corporate.apply.frontend_validation.email_required')],
        ['input[name="phone"]', 'presence', gmtrans('corporate.apply.frontend_validation.phone_required')],
    ];

    $form.nod(metrics, options);
})();
